.navlist {
	--duration: 0.15s;
	display: flex;
	gap: var(--size-2);
	flex-direction: column;
}

.navlink {
	width: 100%;
	display: flex;
	align-items: center;
	gap: var(--size-4);
	text-decoration: none;
	color: var(--color-text);
	padding: var(--size-4);
	background-color: transparent;
	border: none;
	font-weight: 500;
	transition: color var(--duration) ease;

	&:not(:has(+ .subnav))[data-active="true"] {
		color: var(--color-primary-foreground);
	}

	@media (min-width: 540px) {
		padding: var(--size-3) var(--size-4);
	}
}

.navitem {
	display: block;
	width: 100%;
	background-color: transparent;
	border: none;
	border-radius: var(--radius-md);
	transition:
		background-color var(--duration) ease,
		box-shadow var(--duration) ease;

	&:has(.navlink:hover) {
		background-color: light-dark(var(--gray-400), var(--gray-800));
	}

	&:has(.navlink[data-active="true"]) {
		background-color: var(--color-surface);
		box-shadow: var(--shadow-sm);
	}
}

.subnav {
	height: 0;
	opacity: 0;
	transform: translateY(-10px);
	overflow: clip;
	transition:
		opacity var(--duration),
		transform var(--duration);

	.navlink[data-active="true"] + & {
		height: auto;
		opacity: 1;
		transform: translateY(0);
	}

	@supports (height: calc-size(auto, size)) {
		transition:
			height var(--duration),
			opacity var(--duration),
			transform var(--duration);

		.navlink[data-active="true"] + & {
			height: calc-size(auto, size);
		}
	}
}

.subnavlist {
	display: flex;
	flex-direction: column;
	gap: var(--size-2);
	padding: var(--size-2);
	border-top: var(--size-border) solid var(--color-background);
}

.subnavitem {
	border-radius: var(--radius-md);
	background-color: transparent;
	font-size: var(--text-caption);
	transition:
		background-color var(--duration),
		box-shadow var(--duration);

	&:has(.navlink:hover) {
		background-color: var(--color-surface-hover);
	}

	&:has(.navlink[data-active="true"]) {
		background-color: var(--color-primary-background);
	}
}

.navlabel {
	display: none;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	@media (min-width: 540px) {
		display: block;
	}
}

.badge {
	margin-left: auto;
	font-size: var(--text-caption);
	font-weight: bold;
	background-color: var(--color-primary);
	padding: var(--size-1) var(--size-3);
	border-radius: var(--radius-lg);
	color: var(--gray-100);
}
